import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_Dtos_ParticipantActivities_ParticipantActivitiesDto,
} from '../../services/wealthlane-identity-services';

const useGetIdentityCustomerDashboard = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_Dtos_ParticipantActivities_ParticipantActivitiesDto | undefined,
  unknown
> => {
  const identityCustomerDashboard = useQuery(['getIdentityCustomerDashboard'], async () => {
    return await handleRequest(DashboardService.getApiIdentityApiAppDashboardAdminDashboard());
  });

  return identityCustomerDashboard;
};

export default useGetIdentityCustomerDashboard;
